import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate
} from 'react-router-dom';
import Navbar from '../components/Navbar';
import VideoBackground from '../components/VideoBackground';
import UniversitySlider from '../components/UniversitySlider';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import CTASection from '../components/SignupForm/CTASection';


import SignInSignUp from './SignInSignUp';
import SignupForm from '../components/SignupForm/SignupForm';
import 'jquery';
import SEO from '../components/SEO';
import ChatBot from '../components/chatbot/Chatbot';
import Slider from 'react-slick';
import { FEATURED_UNIVERSITIES } from './universities';



import Header from '../components/Header';
import '../App.css';
// Import other components used in home page

const Home = ({isAuthenticated,handleLogout}) => {
    const [cardIndex, setCardIndex] = useState(0);
    const [user, setUser] = useState(null);
      const [chatOpen, setChatOpen] = useState(false);
  const [botOpen, setBotOpen] = useState(false);


    const [navbarVisible, setNavbarVisible] = useState(true);
    const [activeLink, setActiveLink] = useState('home');
    const [popup, setPopup] = useState({ show: false, content: '' });

const WHATSAPP_NUMBER = "16232123213"; // no +, no spaces
const WHATSAPP_MESSAGE = encodeURIComponent(
  "Hello Admissions Express! I would like to get more information."
);


    const apiUrlRootPath = process.env.REACT_APP_API_URL;
  useEffect(() => {
    // Load popup once on page load. The backend now returns rotation metadata
    // but preserves all images — the frontend will pick which image to show.
    let mounted = true;
    async function loadPopup() {
      try {
       const res = await axios.get(`${apiUrlRootPath}/blog/popup`, { cache: 'no-store' });

        if (!mounted) return;
        if (res.data?.content) {
          setPopup({
            show: true,
            content: res.data.content,
            rotationIndex: res.data?._rotation?.index ?? null,
          });
        }
      } catch (err) {
        console.error('Popup rotation fetch failed:', err);
      }
    }

    loadPopup();
    return () => { mounted = false; };
  }, [apiUrlRootPath]);


{/* <button 
  className="chat-toggle-btn"
  onClick={() => {
    setChatOpen(!chatOpen);

    const whatsapp = document.querySelector(".whatsapp-float");
    if (whatsapp) {
      whatsapp.style.display = !chatOpen ? "none" : "flex"; // hide if opening, show if closing
    }
  }}
>
  {chatOpen ? "Close Chat" : "Chat with Us"}
</button> */}

   const successStories = [
  {
    name: 'Sohaib Khan',
    university: 'University of Arizona',
    testimonial: 'Thanks to Admissions Express, I secured admission into my dream university in the USA. The guidance was exceptional!',
  },
  {
    name: 'Faisal Iqbal',
    university: 'University of California, Berkeley',
    testimonial: 'Admissions Express made my university admission seamless and stress-free.',
  },
  {
    name: 'Muhammad Rehan',
    university: 'New York University',
    testimonial: 'I am grateful for the personalized support from Admissions Express. Highly recommended!',
  },
  {
    name: 'Ali Ansar',
    university: 'University of Michigan',
    testimonial: 'With the help of Admissions Express, I achieved my goal of studying in the USA effortlessly.',
  },
  {
    name: 'Usman Ghani',
    university: 'Central Michigan University',
    testimonial: 'Exceptional service and guidance throughout my application process!',
  },
];
     
    const howitworks = [
      {
        title: 'Create Your Profile',
        description: 'Begin by creating a comprehensive profile that includes your academic records, extracurricular achievements, and career interests.',
      },
      {
        title: 'Get Matched with Universities',
        description: 'Use our AI-powered Profile Matching to identify best-fit universities and programs.',
      },
      {
        title: 'Consult with Advisors',
        description: 'Speak with a U.S.-based advisor within four hours of your request to get personalized guidance.',
      },
      {
        title: 'Submit Applications',
        description: 'Apply to multiple universities without restrictions and receive support throughout each step of the process.',
      },
      {
        title: 'Prepare for Success',
        description: 'Benefit from our financial aid assistance, interview preparation, and visa application guidance to maximize your chances of success.',
      },
      {
        title: 'Receive Admissions Notifications',
        description: 'With a 99% success rate, you’ll soon be on your way to attending a university that aligns with your goals.',
      }
    ];
    const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 700,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  pauseOnHover: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      }
    }
  ]
};
const GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

useEffect(() => {
  const el = document.getElementById('contactMap');
  if (!el) return;

  if (!GOOGLE_MAPS_KEY) {
    console.error('REACT_APP_GOOGLE_MAPS_API_KEY is missing');
    return;
  }

  function init() {
    if (!window.google?.maps) return;

    const map = new window.google.maps.Map(el, {
      center: { lat: 25, lng: 35 },
      zoom: 2,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
    });

    // Use coordinates first (no Geocoding required)
    const locations = [
      { title: 'USA Office', position: { lat: 33.414, lng: -111.909 } },   // Tempe, Arizona
      { title: 'Pakistan Office', position: { lat: 34.7459, lng: 72.3639 } }, // Barikot, Swat
    ];

    const bounds = new window.google.maps.LatLngBounds();

    locations.forEach((loc) => {
      const marker = new window.google.maps.Marker({
        map,
        position: loc.position,
        title: loc.title,
      });

      const info = new window.google.maps.InfoWindow({
        content: `<strong>${loc.title}</strong>`,
      });

      // ✅ Google Maps uses addListener, not addEventListener
      marker.addListener('click', () => info.open({ anchor: marker, map }));

      bounds.extend(marker.getPosition());
    });

    map.fitBounds(bounds);
  }

  // load JS API once
  if (window.google?.maps) {
    init();
  } else {
    const existing = document.getElementById('gmaps-js');
    if (existing) {
      existing.addEventListener('load', init, { once: true });
    } else {
      const s = document.createElement('script');
      s.id = 'gmaps-js';
      s.async = true;
      s.defer = true;
      s.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_KEY}`;
      s.onload = init;
      s.onerror = () => console.error('Failed to load Google Maps JS script');
      // Auth failures (referrer/billing/etc.)
      window.gm_authFailure = () =>
        console.error('Google Maps auth failed. Check key, referrers, billing, and enabled APIs.');
      document.body.appendChild(s);
    }
  }
}, [GOOGLE_MAPS_KEY]);
useEffect(() => {
  const storedUser = localStorage.getItem('user');
  const token = localStorage.getItem('authToken');
  if (storedUser && token) {
    try {
      setUser(JSON.parse(storedUser));
    } catch (e) {
      console.error('Error parsing user from localStorage', e);
    }
  }
}, []);


// After popup HTML is inserted, show only the rotated image (if rotationIndex is provided)
useEffect(() => {
  if (!popup.show || !popup.content) return;
  // run after a tick so the DOM from dangerouslySetInnerHTML is available
  const t = setTimeout(() => {
    try {
      const container = document.querySelector('.popup-body');
      if (!container) return;
      const imgs = Array.from(container.querySelectorAll('img'));
      if (!imgs.length) {
        // ensure default padding when not an image-only popup
        const card = document.querySelector('.popup-content');
        if (card) {
          card.classList.remove('image-only');
          card.style.padding = '';
        }
        return;
      }

      // hide all images except the chosen rotation index (if provided)
      const keep = typeof popup.rotationIndex === 'number' ? popup.rotationIndex : 0;
      imgs.forEach((img, i) => {
        img.style.display = i === keep ? 'block' : 'none';
        img.style.margin = '0';
        img.style.maxWidth = '100%';
        img.style.height = 'auto';
        img.loading = 'lazy';
      });

      // remove extra padding on the popup card for an image-only layout
      const card = document.querySelector('.popup-content');
      if (card) {
        card.style.padding = '0';
        card.classList.add('image-only');
      }
    } catch (e) {
      // silent
    }
  }, 30);
  return () => clearTimeout(t);
}, [popup.show, popup.content, popup.rotationIndex]);


  const ourservices = [
  {
    fa_icon: "fa-id-card",
    title: "I-20 Assistance",
    description:
      "End-to-end guidance to obtain and review your I-20, including timelines, fees, and school coordination.",
  },
  {
    fa_icon: "fa-passport",
    title: "DS-160 Assistance",
    description:
      "Step-by-step DS-160 form completion, photo requirements, and a complete document checklist.",
  },
  {
    fa_icon: "fa-university",
    title: "University Selection",
    description:
      "Personalized shortlists matched to your profile, budget, deadlines, and scholarship options.",
  },
  {
    fa_icon: "fa-stamp",
    title: "Visa Preparation",
    description:
      "Mock interviews, document prep, fee payment guidance, appointment booking, and travel tips.",
  },
  {
    fa_icon: "fa-home",
    title: "Student Accommodation",
    description:
      "On-/off-campus housing options, contract review, budgeting, and arrival support.",
  },
];

// Inline SVG fallbacks for service icons (no extra files). Returns an SVG string.
function getIconSvg(name) {
  switch (name) {
    case 'fa-id-card':
      return `<!-- id-card -->
        <svg viewBox="0 0 64 64" width="48" height="48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" fill="currentColor"><rect x="4" y="8" width="56" height="48" rx="4" ry="4" fill="none" stroke="currentColor" stroke-width="3"/><circle cx="20" cy="28" r="6" fill="currentColor"/><rect x="34" y="22" width="18" height="4" fill="currentColor"/><rect x="34" y="30" width="18" height="4" fill="currentColor"/></svg>`;
    case 'fa-passport':
      return `<!-- passport -->
        <svg viewBox="0 0 64 64" width="48" height="48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" fill="currentColor"><rect x="8" y="6" width="40" height="52" rx="3" ry="3" fill="none" stroke="currentColor" stroke-width="3"/><path d="M20 20c6 0 8 6 8 6s-2 6-8 6-8-6-8-6 2-6 8-6z" fill="currentColor"/></svg>`;
    case 'fa-university':
      return `<!-- university -->
        <svg viewBox="0 0 64 64" width="48" height="48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" fill="currentColor"><polygon points="32,8 4,24 60,24" fill="currentColor"/><rect x="8" y="28" width="48" height="24" fill="none" stroke="currentColor" stroke-width="2"/><rect x="14" y="34" width="8" height="12" fill="currentColor"/><rect x="28" y="34" width="8" height="12" fill="currentColor"/><rect x="42" y="34" width="8" height="12" fill="currentColor"/></svg>`;
    case 'fa-stamp':
      return `<!-- stamp -->
        <svg viewBox="0 0 64 64" width="48" height="48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" fill="currentColor"><rect x="10" y="8" width="44" height="32" rx="4" ry="4" fill="none" stroke="currentColor" stroke-width="3"/><circle cx="32" cy="28" r="8" fill="currentColor"/></svg>`;
    case 'fa-home':
      return `<!-- home -->
        <svg viewBox="0 0 64 64" width="48" height="48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" fill="currentColor"><path d="M8 28 L32 8 L56 28 V52 H38 V36 H26 V52 H8 Z" fill="currentColor"/></svg>`;
    default:
      // generic circle
      return `<svg viewBox="0 0 64 64" width="48" height="48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" fill="currentColor"><circle cx="32" cy="32" r="14" fill="currentColor"/></svg>`;
  }
}

      const courses = [
          {
            name: 'Computer Science',
            description: 'Learn programming and software development',
            detailedDescription: 'Our Computer Science program covers fundamental concepts of programming, algorithms, data structures, and software engineering. Students will gain hands-on experience with modern technologies.',
            rank: '#1 Most Popular Major'
          },
          {
            name: 'Business Administration',
            description: 'Develop business management skills',
            detailedDescription: 'The Business Administration program provides comprehensive knowledge of business principles, management strategies, and entrepreneurship. Students learn through real-world case studies and internships.',
            rank: '#2 Most Popular Major'
          },
          {
            name: 'Engineering',
            description: 'Solve complex technical challenges',
            detailedDescription: 'Our Engineering program offers specializations in mechanical, electrical, and civil engineering. Students work on innovative projects and learn from industry-experienced faculty.',
            rank: '#3 Most Popular Major'
          }
        ];
      
      // const cards = [
      //   {
      //     name: 'University of California',
      //     description: 'Highly ranked public university in California.',
      //     detailedDescription: 'The University of California is known for its world-class research and academic excellence. It offers a variety of undergraduate and graduate programs in diverse fields.',
      //     rank: '1st in Public Universities (U.S.)'
      //   },
      //   {
      //     name: 'Cincinnati University',
      //     description: 'Top-tier university in Ohio.',
      //     detailedDescription: 'The University of Cincinnati is renowned for its engineering programs and innovative teaching methods. It has a vibrant campus and offers multiple research opportunities.',
      //     rank: '75th in National Universities (U.S.)'
      //   },
      //   {
      //     name: 'University of Arizona',
      //     description: 'Research-focused university in the Southwest.',
      //     detailedDescription: 'Located in Tucson, the University of Arizona is famous for its research in agriculture and environmental science. It also has a strong business and law school.',
      //     rank: '115th in National Universities (U.S.)'
      //   }
      // ];
      
const teamMembers = [
{
  id: 1,
  name: 'Maaz Khan (U.S)',
  role: 'Founder',
  avatar: require('../assets/images/webp/Maaz.webp'),
  description:
    'Maaz is the visionary behind our company’s success, leading with passion, innovation, and a relentless drive for excellence. With a strong focus on growth, client satisfaction, and cutting-edge strategies, he empowers the team to deliver exceptional results and shape the future of our industry.',
},

  {
    id: 2,
    name: 'Nangyalay Khan (U.S)',
    role: 'CEO',
    avatar: require('../assets/images/webp/Nangyalay.webp'),
    description:
"Nangyalay, our dynamic and forward-thinking CEO, brings over a decade of visionary leadership, strategic business acumen, and a deep passion for innovation. His proven expertise in driving organizational growth, fostering a culture of creativity, and leading high-performing teams continues to position our company at the forefront of industry transformation and long-term success."  },

  
{
    id: 3,
    name: 'Wallay Jonty (U.S)',
    role: 'Director Admissions',
    avatar: require('../assets/images/webp/wallay.jpg'),
    description:
      'Wallay drives strategy and culture, aligning growth with integrity and measurable outcomes. He builds high-trust teams, forges partnerships, and turns complex challenges into simple systems that deliver value for learners and institutions.',
  },
  {
    id: 4,
    name: 'Baswar Shah (Pak)',
    role: 'Relation Manager',
    avatar: require('../assets/images/webp/baswar.webp'),
      description:'Baswar excels at building strong partnerships. His dedication to client success and collaboration keeps our relationships thriving.',
  },
  {
    id: 5,
    name: 'Habib Ul Wahab(Pak)',
    role: 'Consultant',
    avatar: require('../assets/images/webp/habib.webp'),
    description:
      'Habib strengthens relationships with students, families, and campuses, making communication seamless and transparent. He turns feedback into improvements, resolves issues quickly, and keeps long-term partnerships healthy and productive.',
  },
  // {
  //   id: 5,
  //   name: 'Nangyalay Khan (USA)',
  //   role: 'Consultant',
  //   avatar: require('../assets/images/webp/Nangyalay.webp'),
  //   description:
  //     'Nangyalay brings strategic vision and innovative problem-solving to the table. With deep industry insight and a collaborative spirit, He drives transformative results for our clients.',
  // },
];




      const handleScroll = () => {
        if (window.scrollY > 100) {
          setNavbarVisible(false);
        } else {
          setNavbarVisible(true);
        }
      };
    
      // const handleSlide = (direction) => {
      //   if (direction === 'left') {
      //     setCardIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : cards.length - 1));
      //   } else if (direction === 'right') {
      //     setCardIndex((prevIndex) => (prevIndex < cards.length - 1 ? prevIndex + 1 : 0)); // One card at a time
      //   }
      // };
    
      const handleLinkClick = (link) => {
        setActiveLink(link);
      };
    
      useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
      }, []);
    // Add this function before the return statement
    const [formData, setFormData] = useState({
      name: '',
      email: '',
      subject: '',
      message: ''
  });
  
  const handleInputChange = (e) => {
      setFormData({
          ...formData,
          [e.target.name]: e.target.value
      });
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
        console.log('Sending form data:', formData); // Add this to debug
        const response = await axios.post(`${apiUrlRootPath}/questionnaires/contact`, formData);
        if (response.status === 200) {
            setFormData({
                name: '',
                email: '',
                subject: '',
                message: ''
            });
            alert('Message sent successfully!');
        }
    } catch (error) {
        console.log('Error details:', error); // Add this to debug
        alert('Failed to send message. Please try again.');
    }
};
  // small client-side auth check to avoid flashing signup/login when user is already logged in
  const loggedIn = Boolean(
    (typeof window !== 'undefined' && window.localStorage && (localStorage.getItem('authToken') || localStorage.getItem('user')))
  );
  return (
    <>
     <SEO 
        title="University Admissions Help | Admissions Express USA"
        description="We assist United States students with university admissions, English tests, and personalized guidance for studying in universities."
        canonicalUrl="https://admissionsexpress.com/"
      />
      {/* Inline styles for icon fallbacks and chat animations (keeps changes in this file only) */}
  <style>{`
        /* Contact section styles */
        .right-info {
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 4px 16px rgba(0,0,0,0.1);
          padding: 24px;
        }

        .right-info ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .right-info li {
          padding: 20px 0;
          border-bottom: 1px solid #eee;
        }

        .right-info li:last-child {
          border-bottom: none;
        }

        .right-info h6 {
          color: var(--primary-color);
          font-size: 18px;
          margin-bottom: 12px;
          font-weight: 600;
        }

        .right-info span {
          display: block;
          margin: 8px 0;
        }

        .right-info a {
          color: #333;
          text-decoration: none;
          transition: color 0.2s;
        }

        .right-info a:hover {
          color: var(--primary-color);
        }

        /* Map styles */
        .map-container {
          margin: 16px 0;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 4px 12px rgba(0,0,0,0.08);
        }

        .contact-map {
          width: 100%;
          height: 300px;
          border: none;
        }

        .location-details {
          margin-top: 16px;
          font-size: 14px;
          color: #666;
        }

        .location-details p {
          margin: 8px 0;
          display: flex;
          align-items: flex-start;
          line-height: 1.4;
        }

        .location-details i {
          color: var(--primary-color);
          margin-right: 8px;
          margin-top: 4px;
          flex-shrink: 0;
        }

        /* Service icons */
        .service-icon svg { display: inline-block; vertical-align: middle; width:48px; height:48px; }
        .service-icon { display:inline-flex; align-items:center; justify-content:center; width:64px; height:64px; margin-bottom:12px; }

        /* theme color for service icons */
        .service-icon { color: var(--primary-color); }

        /* Global button styles */
        .button,
        .cta-button,
        .chat-fab,
        .chat-icon {
          height: 56px;
          padding: 0 24px;
          border-radius: 28px;
          border: none;
          outline: none;
          cursor: pointer;
          font-size: 16px;
          font-weight: 500;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
          background-color: var(--primary-color);
          color: white;
          text-decoration: none;
          box-shadow: 0 4px 12px rgba(60, 124, 255, 0.2);
        }

        .button:hover,
        .cta-button:hover,
        .chat-fab:hover,
        .chat-icon:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(60, 124, 255, 0.3);
        }

        .button:active,
        .cta-button:active,
        .chat-fab:active,
        .chat-icon:active {
          transform: translateY(0);
          box-shadow: 0 4px 12px rgba(60, 124, 255, 0.2);
        }

        /* Floating Chat UI - pinned bottom-right; icons stack above main FAB */
        .chat-fab-container {
          position: fixed !important;
          right: 24px !important;
          bottom: 24px !important;
          top: auto !important;
          left: auto !important;
          z-index: 99999 !important;
          display: flex;
          /* keep main FAB at bottom and secondary icons above it */
          flex-direction: column-reverse;
          align-items: center;
          gap: 12px;
          pointer-events: none; /* container doesn't block underlying content */
        }

        .chat-fab,
        .chat-icon {
          width: 56px;
          height: 56px;
          min-width: 56px;
          min-height: 56px;
          border-radius: 50%;
          border: none;
          outline: none;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          background-color: var(--primary-color);
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
          transition: transform 0.25s ease, opacity 0.25s ease;
          appearance: none;
          -webkit-appearance: none;
          padding: 0;
          margin: 0;
          position: relative; /* allow stacking inside container */
          pointer-events: auto; /* buttons are clickable */
        }

        .chat-fab svg,
        .chat-icon svg {
          width: 24px;
          height: 24px;
        }

        .chat-fab svg { width: 28px; height: 28px; }

        .chat-fab.open { transform: rotate(45deg); }

        /* hidden state for secondary icons */
        .chat-icon { opacity: 0; transform: translateY(6px) scale(0.9); }
        .chat-icon.show { opacity: 1; transform: translateY(0) scale(1); }

        .chat-icon.whatsapp { background-color: #25D366; }
        .chat-icon.bot { background-color: var(--primary-color); }

        .chat-fab:hover, .chat-icon:hover { transform: translateY(-4px) scale(1.02); box-shadow: 0 6px 16px rgba(0,0,0,0.25); }

        /* small responsive tweak so chat buttons don't cover content on small screens */
        @media (max-width: 480px) {
          .chat-fab-container {
            right: 12px;
            bottom: 16px;
          }
        }
      `}</style>
      <style>{`
        /* Ensure hero/banner is pushed below fixed header */
        .main-banner { padding-top: 72px; }
        .header.fixed-top { z-index: 1100; }
        /* Small tweak: make sure CTA buttons in hero are visible above overlays */
        .main-button-red .cta-button { z-index: 2; position: relative; }
      `}</style>
    {/* <!-- ***** Header Area Start ***** --> */}
<Header 
  user={user} 
  isAuthenticated={!!user} 
  handleLogout={() => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    setUser(null);
    if (typeof window !== 'undefined') window.location.href = '/';
  }} 
/>


{popup.show && (
  <div
    className="popup-overlay"
    onClick={() => setPopup({ show: false, content: '' })}
  >
    <div
      className="popup-content"
      onClick={e => e.stopPropagation()}
    >
      <button
        className="popup-close"
        onClick={() => setPopup({ show: false, content: '' })}
      >
        &times;
      </button>
      <div
        className="popup-body"
        dangerouslySetInnerHTML={{ __html: popup.content }}
      />
    </div>
  </div>
)}


    {/* <!-- ***** Header Area End ***** --> */}

    {/* <!-- ***** Main Banner Area Start ***** --> */}
    <section class="section main-banner section-bordered" id="top" data-section="section1">
      {/* <video autoplay muted loop id="bg-video">
      
  </video> */}
      
      {/* <video autoPlay loop muted id="bg-video">
        <source src="/vid.mp4" type="video/mp4" />
      </video> */}


<img src="assets/images/banner.jpg"className="hero-students-image" alt="Students at university campus" />

      <div class="video-overlay header-text">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="caption">
                {/* <h6>Hello Students</h6> */}
                <h1>Welcome to <br></br>Admissions Express</h1>
                <p>We help you study in USA</p>
                <div class="main-button-red">
                  <div className="scroll-to-section">
                    { !loggedIn ? (
                      <Link to="/auth" className="cta-button">Book a Consultation</Link>
                    ) : (
                      <Link to="/dashboard" className="cta-button dashboard-btn">Go to Dashboard</Link>
                    ) }
                    <a href="/#aboutus" className="cta-button learn-more-btn">Learn More</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    {/* <!-- ***** Main Banner Area End ***** --> */}
    

    <section class="services">

      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="owl-service-item owl-carousel">

              <div class="item">
                <div class="icon">
                  <img src="assets/images/webp/service-icon-01.webp" alt="Best Education service icon" />
                </div>
                <div class="down-content">
                  <h4>Best Education</h4>
                  <p>Suspendisse tempor mauris a sem elementum bibendum. Praesent facilisis massa non vestibulum.</p>
                </div>
              </div>

              <div class="item">
                <div class="icon">
                  <img src="assets/images/webp/service-icon-02.webp" alt="Best Teachers service icon" />
                </div>
                <div class="down-content">
                  <h4>Best Teachers</h4>
                  <p>Suspendisse tempor mauris a sem elementum bibendum. Praesent facilisis massa non vestibulum.</p>
                </div>
              </div>

              <div class="item">
                <div class="icon">
                  <img src="assets/images/webp/service-icon-03.webp" alt="Best Students service icon" />

                </div>
                <div class="down-content">
                  <h4>Best Students</h4>
                  <p>Suspendisse tempor mauris a sem elementum bibendum. Praesent facilisis massa non vestibulum.</p>
                </div>
              </div>

              <div class="item">
                <div class="icon">
                  <img src="assets/images/webp/service-icon-02.webp" alt="Online Meeting service icon" />

                </div>
                <div class="down-content">
                  <h4>Online Meeting</h4>
                  <p>Suspendisse tempor mauris a sem elementum bibendum. Praesent facilisis massa non vestibulum.</p>
                </div>
              </div>

              <div class="item">
                <div class="icon">
                  <img src="assets/images/webp/service-icon-03.webp"  alt="Best Networking service icon" />
                </div>
                <div class="down-content">
                  <h4>Best Networking</h4>
                  <p>Suspendisse tempor mauris a sem elementum bibendum. Praesent facilisis massa non vestibulum.</p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>

    {/* {!user && <SignupForm />} */}
    <CTASection />
    {/* section 1: About Us */}
    
    <section class="our-courses section-bordered" id="aboutus">
      
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-heading">
              <h2>About Us</h2>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="row">
           
              <div class="col-lg-12">
              <p>At Admissions Express, our mission is to unlock opportunities for students globally. We combine innovative technology with personalized guidance from our team of U.S.-based advisors, who are available to speak with students within four hours of any request. With our cutting-edge AI-powered Profile Matching, we provide tailored university recommendations that align with each student's academic profile, interests, and career aspirations.</p>
              <p>Our platform allows students to apply to multiple universities without restrictions and offers support for applications to institutions in the U.S., Canada, Europe, and Australia. Our commitment to quality has resulted in a 99% admissions success rate, with an over 80% visa approval rate for international students. Trust AdmissionsExpress.com to bring expertise, innovation, and personalized support to your admissions journey.</p>
              
              </div>
            <div className="row text-center feature-strip py-4 mt-4 g-4">
  <div className="col-12 col-md-4">
    <div className="feature-box">
      <i className="bi bi-globe2"></i>
      <div className="feature-label">Students from<br />around the world</div>
    </div>
  </div>

  <div className="col-12 col-md-4">
    <div className="feature-box">
      <i className="bi bi-cpu"></i>
      <div className="feature-label">AI-powered<br />matching</div>
    </div>
  </div>

  <div className="col-12 col-md-4">
    <div className="feature-box">
      <i className="bi bi-mortarboard"></i>
      <div className="feature-label">99% admissions<br />success rate</div>
    </div>
  </div>
</div>

            </div>
            </div>
        </div>

      </div>
    </section>


    {/* Section 2: Our Services */}
    <section class="apply-now" id="ourservices">
      <div class="container">
        <div class="row">
          
        <div class="col-lg-12">
            <div class="section-heading">
              <h2>Our Services</h2>
            </div>
          </div>
          <div class="col-lg-12 align-self-center">
            <div class="row">
              
            {ourservices.map((item, index) => (
                
                <div class="col-lg-4">
                  <div class="item">
                  <div className="service-icon" dangerouslySetInnerHTML={{__html: getIconSvg(item.fa_icon)}} />
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                    <div class="read-more-button">
  <div class="scroll-to-section">
    <a href="#">Read More &gt;&gt;</a>
  </div>
</div>
 
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>


    {/* Student Services
    <section class="our-courses section-bordered" id="studentservices">
      <div class="container">
        <div class="section-heading">
              <h2>Student Services</h2>
            </div>
        <div class="timeline">
            <div class="timeline-item">
                <div class="timeline-item-content">
                    <div class="icon"><i class="fa fa-graduation-cap"></i></div>
                    <h3>Student Visa</h3>
                    <p>We offer comprehensive guidance for your student visa application process. Our expert team assists you in preparing, submitting, and tracking your visa application to ensure compliance with immigration requirements.</p>
                </div>
            </div>
            <div class="timeline-item">
                <div class="timeline-item-content">
                    <div class="icon"><i class="fa fa-refresh"></i></div>
                    <h3>Extend Your Visa</h3>
                    <p>If your study program needs an extension, we provide step-by-step support to ensure a smooth process. From preparing documents to navigating policies, we ensure a hassle-free experience.</p>
                </div>
            </div>
            <div class="timeline-item">
                <div class="timeline-item-content">
                    <div class="icon"><i class="fa fa-university"></i></div>
                    <h3>Student Admission</h3>
                    <p>We help you apply to top universities worldwide, guiding you from selecting the right course to submitting applications. Our expertise ensures your profile stands out.</p>
                </div>
            </div>
            <div class="timeline-item">
                <div class="timeline-item-content">
                    <div class="icon"><i class="fa fa-home"></i></div>
                    <h3>Student Accommodation</h3>
                    <p>Find affordable and comfortable housing near your university. From shared apartments to private residences, we help you find the perfect home.</p>
                </div>
            </div>
            <div class="timeline-item">
                <div class="timeline-item-content">
                    <div class="icon"><i class="fa fa-search"></i></div>
                    <h3>Find a University</h3>
                    <p>Discover universities that align with your goals. Create a profile, upload documents, and let our platform recommend the best-fit universities.</p>
                </div>
            </div>
            <div class="timeline-item">
                <div class="timeline-item-content">
                    <div class="icon"><i class="fa fa-money"></i></div>
                    <h3>Find a Scholarship</h3>
                    <p>Access global scholarship opportunities. We help identify options that suit your academic achievements and financial needs.</p>
                </div>
            </div>
        </div>

        <div class="additional-feature">
            <h3>University Profile System</h3>
            <ul>
                <li><i class="fa fa-file"></i> Upload Documents: Store your transcripts, recommendation letters, and CVs securely.</li>
                <li><i class="fa fa-list"></i> Personalized Recommendations: Get university suggestions based on your profile.</li>
                <li><i class="fa fa-bar-chart"></i> Application Tracking: Stay updated on application status with a dashboard.</li>
                <li><i class="fa fa-info-circle"></i> Explore University Insights: Access key details like rankings, fees, and campus life.</li>
            </ul>
        </div>
      </div>
    </section> */}
        <section className="meet-our-team section-bordered neon-frame" id="meet-our-team">
    <div className="container">
      <div className="section-heading">
        <h2>Meet Our Team</h2>
      </div>
      <p className="section-intro">
        Our leadership team brings together expertise, creativity, and commitment to excellence.
        Get to know the people guiding us toward our goals.
      </p>
     <div className="team-grid">
  {teamMembers.map(m => {
    // pull "(US)" out of the name if present; show name without it
    const country = m.country || (m.name.match(/\(([^)]+)\)/)?.[1] ?? null);
    const displayName = m.name.replace(/\s*\([^)]+\)\s*/, '');

    return (
      <div key={m.id} className="team-member-card">
        <div className="team-member-image">
          <img src={m.avatar} alt={displayName} />
        </div>
        <h3 className="team-member-name">{displayName}</h3>
        <h4 className="team-member-role">{m.role}</h4>
        {country && <div className="team-member-country">{country}</div>}
        <p className="team-member-description">{m.description}</p>
      </div>
    );
  })}
</div>

    </div>
  </section>
    {/* message of ceo */}
    <section class="apply-now section-bordered" id="messageceo">
      <div class="container">
      <div class="section-heading">
              <h2>Message From The CEO</h2>
            </div>
        <div class="ceo-section">
<div class="ceo-image">
  <img src="assets/images/Nangyalay.webp" alt="CEO Image" />
</div>

            <div class="ceo-content">
                <h2>Chief Executive Officer</h2>
                <h3>Admissions Express</h3>
                <p>Dear Students, Parents, and Partners, Welcome to Admissions Express – your trusted partner in pursuing higher education abroad. At Admissions Express, we take immense pride in being a part of your academic journey, helping you transform your dreams of studying in world-renowned institutions into a reality.</p>

                <p>We understand that the decision to study abroad is not just about choosing a course or university; it’s about embarking on a life-changing journey filled with opportunities, challenges, and growth. With this in mind, our team of dedicated experts works tirelessly to provide personalized guidance, tailored solutions, and unwavering support at every step of the way.</p>

                <p>Whether it’s finding the perfect university, securing scholarships, navigating the complexities of student visas, or ensuring a seamless transition to your new home, Admissions Express is here to make the process simpler, faster, and stress-free. Our partnerships with leading universities and institutions around the world enable us to offer a wide range of opportunities, ensuring that each student finds the best fit for their aspirations.</p>

                <p>At Admissions Express, we believe in empowering students to reach their full potential by breaking barriers and building bridges to global education. Together, let’s create a future where your goals have no limits and your education knows no boundaries.</p>

                <p class="quote">Thank you for trusting us to be a part of your journey. The entire team and I look forward to guiding you towards your brightest future.</p>
            </div>
        </div>
      </div>
    </section>

    


{/* <section className="featured-logos">
  <h2 className="featured-logos__heading">Featured Universities</h2>

  <Slider
    dots
    infinite
    speed={700}
    slidesToShow={3}
    slidesToScroll={1}
    autoplay
    autoplaySpeed={4000}
    pauseOnHover
    cssEase="ease-in-out"
    responsive={[
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 600,  settings: { slidesToShow: 1 } }
    ]}
  >
    {FEATURED_UNIVERSITIES.map((u) => (
      <div key={u.name} className="featured-logos__tile">
        <a
          href={u.websiteURL}
          target="_blank"
          rel="noopener noreferrer"
          className="featured-logos__link"
        >
          <div className="featured-logos__box">
            <img
              src={u.logoPath}  // e.g. "/assets/images/boulder.png"
              alt={`${u.name} logo`}
              className="featured-logos__img"
              width={160}
              height={90}
              loading="lazy"
              onError={(e) => {
                e.currentTarget.src = "/assets/images/placeholder.webp";
              }}
            />
          </div>
          <div className="featured-logos__caption">
            <h4 className="featured-logos__title">{u.name}</h4>
            <p className="featured-logos__sub">{u.city}</p>
          </div>
        </a>
      </div>
    ))}
  </Slider>
</section> */}


    {/* <section class="upcoming-meetings" id="meetings">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-heading">
              <h2>Upcoming Meetings</h2>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="categories">
              <h4>Meeting Catgories</h4>
              <ul>
                <li><a href="#">Sed tempus enim leo</a></li>
                <li><a href="#">Aenean molestie quis</a></li>
                <li><a href="#">Cras et metus vestibulum</a></li>
                <li><a href="#">Nam et condimentum</a></li>
                <li><a href="#">Phasellus nec sapien</a></li>
              </ul>
              <div class="main-button-red">
                <a href="meetings.html">All Upcoming Meetings</a>
              </div>
            </div>
          </div>
          <div class="col-lg-8">
            <div class="row">
              <div class="col-lg-6">
                <div class="meeting-item">
                  <div class="thumb">
                    <div class="price">
                      <span>$22.00</span>
                    </div>
                    <a href="meeting-details.html"><img src="assets/images/webp/meeting-01.jpg" alt="New Lecturer Meeting" /></a>
                  </div>
                  <div class="down-content">
                    <div class="date">
                      <h6>Nov <span>10</span></h6>
                    </div>
                    <a href="meeting-details.html"><h4>New Lecturers Meeting</h4></a>
                    <p>Morbi in libero blandit lectus<br />cursus ullamcorper.</p>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="meeting-item">
                  <div class="thumb">
                    <div class="price">
                      <span>$36.00</span>
                    </div>
                    <a href="meeting-details.html"><img src="assets/images/webp/meeting-02.jpg" alt="Online Teaching" /></a>
                  </div>
                  <div class="down-content">
                    <div class="date">
                      <h6>Nov <span>24</span></h6>
                    </div>
                    <a href="meeting-details.html"><h4>Online Teaching Techniques</h4></a>
                    <p>Morbi in libero blandit lectus<br />cursus ullamcorper.</p>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="meeting-item">
                  <div class="thumb">
                    <div class="price">
                      <span>$14.00</span>
                    </div>
                    <a href="meeting-details.html"><img src="assets/images/webp/meeting-03.jpg" alt="Higher Education" /></a>
                  </div>
                  <div class="down-content">
                    <div class="date">
                      <h6>Nov <span>26</span></h6>
                    </div>
                    <a href="meeting-details.html"><h4>Higher Education Conference</h4></a>
                    <p>Morbi in libero blandit lectus<br />cursus ullamcorper.</p>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="meeting-item">
                  <div class="thumb">
                    <div class="price">
                      <span>$48.00</span>
                    </div>
                    <a href="meeting-details.html"><img src="assets/images/webp/meeting-04.jpg" alt="Student Training" /></a>
                  </div>
                  <div class="down-content">
                    <div class="date">
                      <h6>Nov <span>30</span></h6>
                    </div>
                    <a href="meeting-details.html"><h4>Student Training Meetup</h4></a>
                    <p>Morbi in libero blandit lectus<br />cursus ullamcorper.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> */}

{/* legacy whatsapp float removed — use the stacked chat-fab-container above to avoid duplicate floating buttons */}

{/* Render the ChatBot component */}
{chatOpen && <ChatBot onClose={() => setChatOpen(false)} />}

    
<section class="our-courses section-bordered" id="englishtest">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 text-center">
        <div class="section-heading et-header">
          <h2>English Tests</h2>
          <p class="et-subtitle">Pick the test that fits your timeline, budget, and target universities.</p>
          {/* <div class="et-tabs" role="tablist" aria-label="View">
            <button class="et-tab active" type="button">Overview</button>
            <button class="et-tab" type="button">Quick Compare</button>
          </div> */}
        </div>
      </div>

      <div class="col-lg-4 col-md-6">
        <div class="et-card">
          <span class="et-badge">Widely Accepted</span>
          <div class="et-card-header">
            <div class="et-icon">📚</div>
            <div>
              <h3>IELTS</h3>
            </div>
          </div>
          <p class="et-text">
            IELTS (International English Language Testing System) is the world’s leading English language test for study, work, and migration, trusted by over 10,000 institutions globally. It assesses four skills: listening, reading, writing, and speaking, and is available in both computer-based and paper-based formats. Recognized for migration to countries like Australia, Canada, New Zealand, the USA, and the UK, IELTS emphasizes real-world communication and human interaction. Tests are under 3 hours, with results in 3–5 days (computer-based). It’s the preferred test for academics, professionals, and migration purposes.
          </p>
          <ul class="et-meta">
            <li><b>Format:</b> Paper / Computer</li>
            <li><b>Length:</b> ~2h 45m</li>
            <li><b>Results:</b> 3–5 days (computer)</li>
          </ul>
          <a href="/dashboard" class="et-link">Learn more</a>
        </div>
      </div>

      <div class="col-lg-4 col-md-6">
        <div class="et-card">
          <div class="et-card-header">
            <div class="et-icon">✨</div>
            <div>
              <h3>Duolingo English Test</h3>
            </div>
          </div>
          <p class="et-text">
            The Duolingo English Test (DET) is a modern, affordable, and convenient online English proficiency test, accepted by thousands of universities and institutions worldwide. It evaluates reading, writing, listening, and speaking skills through adaptive technology. Results are available within 48 hours, and the test takes only about an hour to complete. Unlike traditional tests, it can be taken from home and is widely recognized for its cost-effectiveness and accessibility.
          </p>
          <ul class="et-meta">
            <li><b>Format:</b> Online (at home)</li>
            <li><b>Length:</b> ~80 minutes</li>
            <li><b>Results:</b> ~48 hours</li>
          </ul>
          <a href="/dashboard" class="et-link">Learn more</a>
        </div>
      </div>

      <div class="col-lg-4 col-md-6">
        <div class="et-card">
          <div class="et-card-header">
            <div class="et-icon">🌐</div>
            <div>
              <h3>TOEFL</h3>
            </div>
          </div>
          <p class="et-text">
            The TOEFL (Test of English as a Foreign Language) is a globally recognized English language test for study, work, and migration, widely accepted by universities, governments, and institutions. It assesses four key skills: reading, listening, speaking, and writing, with a focus on academic English. Offered in internet-based and paper-based formats; results typically in ~6 days.
          </p>
          <ul class="et-meta">
            <li><b>Format:</b> Computer-based</li>
            <li><b>Length:</b> ~2–3 hours</li>
            <li><b>Results:</b> ~4–8 days</li>
          </ul>
          <a href="/dashboard" class="et-link">Learn more</a>
        </div>
      </div>
    </div>
  </div>
</section>




    
    <section class="our-courses " id="howitworks">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-heading">
              <h2>How It Works</h2>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="row">
            {/* <Slider {...{
              dots: true,
              infinite: true,
              speed: 700,
              slidesToShow: 3,
              slidesToScroll: 1,
              autoplay: true,
              autoplaySpeed: 4000,
              pauseOnHover: true,
              cssEase: "ease-in-out",
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 2,
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 1,
                  }
                }
              ]
            }}> */}
      

              {howitworks.map((item, index) => (
                
                <div class="col-lg-4">
              <div className="howitworks-content">
                    <span class="howitworks_numbers">{index+1}</span>
                    <h4 className="howitworks-title">{item.title}</h4>
                    <div className="info">
                      <div className="row">
                        <div className="col-12">
                        <p className="howitworks-description">{item.description}</p>
                        </div>
                      </div>
                    </div>
                  </div>
              
            </div>
              ))}
            {/* </Slider>             */}
            </div>
            </div>
        </div>
      </div>
    </section>
    {/* <section class="our-facts">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-12">
                <h2>A Few Facts About Our University</h2>
              </div>
              <div class="col-lg-6">
                <div class="row">
                  <div class="col-12">
                    <div class="count-area-content percentage">
                      <div class="count-digit">94</div>
                      <div class="count-title">Succesed Students</div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="count-area-content">
                      <div class="count-digit">126</div>
                      <div class="count-title">Current Teachers</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="row">
                  <div class="col-12">
                    <div class="count-area-content new-students">
                      <div class="count-digit">2345</div>
                      <div class="count-title">New Students</div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="count-area-content">
                      <div class="count-digit">32</div>
                      <div class="count-title">Awards</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 align-self-center">
            <div class="video">
              <a href="https://www.youtube.com/watch?v=HndV87XpkWg" target="_blank"><img src="assets/images/webp/play-icon.webp" alt="" /></a>
            </div>
          </div>
        </div>
      </div>
    </section> */}
    <section className="student-success-stories section-bordered" id="success-stories">
  <div className="container">
    <div className="section-heading">
      <h2>Student Success Stories</h2>
    </div>
    <Slider {...sliderSettings}>
      {successStories.map((student, index) => (
        <div key={index} className="success-story-card">
          <div className="success-story-image">
            <img 
              src={`https://ui-avatars.com/api/?name=${encodeURIComponent(student.name)}&background=3c7cff&color=fff&size=128`}
              alt={student.name}
            />
          </div>
          <div className="success-story-content">
            <h3 className="student-name">{student.name}</h3>
            <h4 className="student-university">{student.university}, USA</h4>
            <p className="student-testimonial">"{student.testimonial}"</p>
          </div>
        </div>
      ))}
    </Slider>
  </div>
</section>
    <section class="contact-us" id="contact">
      
      <div class="container">
        <div class="row">
        <div class="section-heading">
              <h2>Contact Us</h2>
            </div>
        </div>
        <div class="row">
          <div class="col-lg-8 align-self-center">
            <div class="row">
              <div class="col-lg-12">
                <div class="contact-form">
              <form id="contact" onSubmit={handleSubmit}>
    <div class="row">
        <div class="col-lg-12">
            <h2>Let's get in touch</h2>
        </div>
        <div class="col-lg-4">
            <fieldset>
                <input 
                    name="name" 
                    type="text" 
                    id="name" 
                    placeholder="YOURNAME...*" 
                    required="" 
                    value={formData.name}
                    onChange={handleInputChange}
                />
            </fieldset>
        </div>
        <div class="col-lg-4">
            <fieldset>
                <input 
                    name="email" 
                    type="text" 
                    id="email" 
                    pattern="[^ @]*@[^ @]*" 
                    placeholder="YOUR EMAIL..." 
                    required="" 
                    value={formData.email}
                    onChange={handleInputChange}
                />
            </fieldset>
        </div>
        <div class="col-lg-4">
            <fieldset>
                <input 
                    name="subject" 
                    type="text" 
                    id="subject" 
                    placeholder="SUBJECT...*" 
                    required="" 
                    value={formData.subject}
                    onChange={handleInputChange}
                />
            </fieldset>
        </div>
        <div class="col-lg-12">
            <fieldset>
                <textarea 
                    name="message" 
                    type="text" 
                    class="form-control" 
                    id="message" 
                    placeholder="YOUR MESSAGE..." 
                    required=""
                    value={formData.message}
                    onChange={handleInputChange}
                ></textarea>
            </fieldset>
        </div>
        <div class="col-lg-12">
            <fieldset>
                <button type="submit" id="form-submit" class="button">SEND MESSAGE NOW</button>
            </fieldset>
        </div>
    </div>
</form>
</div>
              </div>
            </div>
          </div>
         <div class="col-lg-4">
  <div class="right-info">
    <ul>
      <li>
        <h6>Phone Numbers</h6>
        <span><a href="tel:+1(623)212-3507">+1(623)212-3507</a></span>
        <span><a href="tel:+1(623)212-3213">+1(623)212-3213</a></span>
      </li>

      <li>
        <h6>Email Address</h6>
        <span><a href="mailto:info@admissionsexpress.com">info@admissionsexpress.com</a></span>
      </li>

      <li class="location-item">
        <h6>Our Locations</h6>
        <div class="map-container">
          <div id="contactMap" class="contact-map" aria-label="AdmissionsExpress offices map"></div>
          <noscript><small>Enable JavaScript to view the map.</small></noscript>
        </div>
        <div class="location-details">
          <p><i class="fas fa-map-marker-alt"></i> USA Office: E Bishop drive Tempe 85282 Arizona USA</p>
          <p><i class="fas fa-map-marker-alt"></i> Pakistan Office: Office no 22, 2nd floor, iqbal khan plaza, opposite punjab, pirbaba road barikot swat</p>
        </div>
      </li>

      <li>
        <h6>Website URL</h6>
        <span><a href="https://admissionsexpress.com">admissionsexpress.com</a></span>
      </li>
    </ul>
  </div>
</div>


        </div> 
      </div>
      <footer className="footer ">
      <div className="footer-container ">
        {/* Logo Column */}
        <div className="footer-column">
          <div className="footer-logo">
            <img src="assets/images/webp/aelogo.webp" alt="Admission Express Logo" className="footer-logo-image" /> <span class="logo-text">AdmissionsExpress</span>
            <br></br>
            <br></br>
            <p>At AdmissionsExpress.com, our mission is to unlock opportunities for students globally. We combine innovative technology with personalized guidance from our team of U.S.-based advisors, who are available to speak with students within four hours of any request. </p>
          </div>
        </div>
        {/* Floating Chat Controls */}
<div className={`chat-fab-container ${botOpen ? "hidden" : ""}`}>
  {/* WhatsApp – ONLY when chat is open */}
  {botOpen && (
    <a
      href="https://wa.me/16232123213?text=Hello%20Admissions%20Express"
      target="_blank"
      rel="noopener noreferrer"
      className="chat-icon whatsapp"
      aria-label="Chat on WhatsApp"
    >z
      <i className="fab fa-whatsapp"></i>
    </a>
  )}

  {/* Main Chat Button */}
  <button
    className={`chat-fab ${botOpen ? "open" : ""}`}
    onClick={() => setBotOpen(true)}
    aria-label="Open chat"
  >
    <i className="fa fa-comments"></i>
  </button>
</div>

{/* Chatbot */}
<ChatBot
  isOpen={botOpen}
  onClose={() => setBotOpen(false)}
/>

        {/* Useful Links Column */}
        <div className="footer-column">
          <h4>Useful Links</h4>
          <ul className="footer-links">
            <li>
              <a href="/#home">Home</a>
            </li>
            <li>
              <a href="/#aboutus">About Us</a>
            </li>
            <li>
              <a href="/#ourservices">Services</a>
            </li>
            <li>
              <a href="/#studentservices">Student Services</a>
            </li>
            <li>
              <a href="/#englishtest">English Test</a>
            </li>
            <li>
              <a href="/#contact">Contact Us</a>
            </li>
          </ul>
        </div>

        {/* Contact Us Column */}
        <div className="footer-column">
          <h4>Contact Us</h4>
          <p><i class="fa fa-map-marker"></i> USA : E Bishop drive Tempe 85282 Arizona USA</p>
          <p><i class="fa fa-map-marker"></i> Pakistan : Office no 22, 2nd floor, iqbal khan plaza, oppsite punjab, pirbaba road barikot swat</p>
          <p><i class="fa fa-phone"></i> <a href='tel:+1(623)212-3507'>+92 319 7370020</a></p>
          <p><i class="fa fa-whatsapp"></i> <a href='tel:+1(623)212-3213'>+1(623)212-3213</a></p>
          <p><i class="fa fa-envelope"></i> <a href='mailto:info@admissionsexpress.com'>info@admissionsexpress.com</a></p>
          <div className="footer-social-icons">
          <a href="https://www.youtube.com/@AdmissionsExpress" target="_blank" rel="noopener noreferrer" className="social-icon">
          <i className="fab fa-youtube"></i>
          </a>
            
            <a href="https://www.instagram.com/admissions_express?igsh=MTNicnFha3V6ajFycw==" target="_blank" rel="noopener noreferrer" className="social-icon">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.facebook.com/share/19sKmWjYwB/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="social-icon">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="https://www.tiktok.com/@admission.express?_t=ZS-8t2VDaOddvM&_r=1" target="_blank" rel="noopener noreferrer" className="social-icon">
              <i className="fab fa-tiktok"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="footer-copyright">
        Copyright © 2025 Admissions Express. All Rights Reserved.
      </div>
    </footer>
      {/* <div class="footer">
        <p>Copyright © 2022 Edu Meeting Co., Ltd. All Rights Reserved.
          <br />Design: <a href="https://templatemo.com" target="_parent" title="free css templates">TemplateMo</a></p>
      </div> */}
    </section>



    </>
    
  );
  
};

export default Home;
